import {ChangeDetectionStrategy, Component, HostBinding, Input} from "@angular/core";
import {NodeModel} from "./model/NodeModel";

@Component({
    selector: 'tfl-tree-view-container',
    template: `
            <div *ngFor="let node of tree">
                <tfl-tree-view-node
                    [openedPanelIconTmpl]="chevronRightTmpl"
                    [closedPanelIconTmpl]="chevronBottomTmpl"
                    [item]="node"
                    [collapsedHeight]="30"
                    [expandedHeight]="30"
                    [hideToggle]="true">
                </tfl-tree-view-node>
            </div>
            <ng-template #chevronRightTmpl>
                <tfl-chevron-right></tfl-chevron-right>
            </ng-template>
            <ng-template #chevronBottomTmpl>
                <tfl-chevron-bottom></tfl-chevron-bottom>
            </ng-template>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TreeViewContainerComponent {
    @Input('tree') tree: NodeModel[];
    @HostBinding('attr.tabindex') tabindex = '-1';
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/business-categories/tree/tree-view-container.component.ts